import { Injectable } from '@angular/core';
import { FeathersAppService } from '@fire/feathers';
import { Router } from '@angular/router';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
import { FeathersConnectionNames } from '../../core/config/feathers-connection-names';



@Injectable()
export class AuthService {

  // current user
  private _user:any = null;


  constructor(
    private feathersAppService:FeathersAppService,
    private router:Router,
  ) {
  }


  get userId():string {
    return _.get(this._user, 'id', null);
  }


  get user():any {
    return this._user;
  }


  logout(navToLoginPage=true) {

    return this.feathersAppService.getConnection(FeathersConnectionNames.Main)
      .then(connection => connection.logout())
      .then(() => {

        this.clearUser();

        if (navToLoginPage) {
          this.router.navigate(['/login']);
        }
      });
  }


  private clearUser() {
    this._user = null;
  }


  private loadUser(user) {
    this._user = user;
    // this._user = getUserModel(user);
  }


  validatePasswordStrength(str) {
    return new Promise((resolve, reject) => {
      if (str.length < 6) {
        reject('Password cannot be less than 6 characters');
      } else if (str.length > 50) {
        reject('Password cannot be more than 50 characters');
      } else if (str.search(/\d/) === -1) {
        reject('Password must contain at least 1 number');
      } else if (str.search(/[a-zA-Z]/) === -1) {
        reject('Password must contain at least 1 letter');
      } else {
        resolve(str);
      }
    });
  }


  validateConfirmationCode(confirmationCode) {
    return new Promise((resolve, reject) => {
      if ( /^\d{4}$/.test(confirmationCode) ) {
        resolve(confirmationCode);
      } else {
        reject('This is not a valid confirmation code.  Please enter four digits.');
      }
    });
  }



  authenticateLocal(creds) {
    return this.feathersAppService.getConnection(FeathersConnectionNames.Main)
      .then(connection => connection.authenticateLocal(creds))
      .then(this.handleSuccessfulLogin.bind(this));
  }


  authenticateJwt() {
    return this.feathersAppService.getConnection(FeathersConnectionNames.Main)
      .then(connection => connection.authenticateJwt())
      .then(this.handleSuccessfulLogin.bind(this));
  }



  private handleSuccessfulLogin(response) {
    if (response.user) {
      this.loadUser(response.user);
      // this.store.dispatch(new LoadUserAction(response.user));
    }

    return response;
  }




  getPasswordFieldValidators() {
    return [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(50),
      Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d)(.{6,50})$/),
    ];
  }


}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/auth.service.ts